import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { ProtectedRoute } from "./components/ProtectedRoute";

import ShopHome from "./pages/shop/ShopHome";
import BrandHome from "./pages/BrandHome";
import Ministere from "./pages/Ministere";
import ProductDetail from "./pages/shop/ProductDetail";
import Cart from "./pages/shop/Cart";
import Checkout from "./pages/shop/Checkout";
import Confirmation from "./pages/shop/Confirmation";
import Merci from "./pages/shop/Merci";
import Login from "./pages/auth/Login";
import AuthCallback from "./pages/auth/AuthCallback";
import { AdminLayout } from "./components/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import Products from "./pages/admin/Products";
import Orders from "./pages/admin/Orders";
import Deliveries from "./pages/admin/Deliveries";
import Reports from "./pages/admin/Reports";
import Users from "./pages/admin/Users";
import Settings from "./pages/admin/Settings";
import AdminMinistere from "./pages/admin/AdminMinistere";
import Reviews from "./pages/admin/Reviews";
import ProjectTracker from "./pages/admin/ProjectTracker";
import Partners from "./pages/admin/Partners";
import Expenses from "./pages/admin/Expenses";
import Consignations from "./pages/admin/Consignations";
import Comptabilite from "./pages/admin/Comptabilite";
import Livreurs from "./pages/admin/Livreurs";
import Studio from "./pages/admin/Studio";
import Guide from "./pages/admin/Guide";
import PartnerDashboard from "./pages/partner/PartnerDashboard";

function AppRouter() {
  const location = useLocation();
  // Handle Emergent Google OAuth callback FIRST (session_id in URL fragment)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  // Compatibilité anciens liens/QR (ancien site en HashRouter: /#/boutique-togo, /#/ministere...)
  if (location.hash?.startsWith("#/")) {
    const p = location.hash.slice(1).toLowerCase();
    const target = p.includes("ministere") ? "/ministere" : "/boutique";
    return <Navigate to={target} replace />;
  }
  return (
    <Routes>
      <Route path="/" element={<BrandHome />} />
      <Route path="/ministere" element={<Ministere />} />
      <Route path="/boutique" element={<ShopHome />} />
      <Route path="/produit/:id" element={<ProductDetail />} />
      <Route path="/panier" element={<Cart />} />
      <Route path="/commander" element={<Checkout />} />
      <Route path="/confirmation/:orderNumber" element={<Confirmation />} />
      <Route path="/merci" element={<Merci />} />
      <Route path="/login" element={<Login />} />

      <Route
        path="/admin"
        element={
          <ProtectedRoute roles={["patron", "vendeur", "associe"]}>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="commandes" element={<Orders />} />
        <Route path="livraisons" element={<ProtectedRoute roles={["patron", "vendeur", "associe"]}><Deliveries /></ProtectedRoute>} />
        <Route path="livreurs" element={<ProtectedRoute roles={["patron", "associe", "vendeur"]}><Livreurs /></ProtectedRoute>} />
        <Route path="studio" element={<ProtectedRoute roles={["patron", "associe", "vendeur"]}><Studio /></ProtectedRoute>} />
        <Route path="produits" element={<ProtectedRoute roles={["patron", "vendeur", "associe"]}><Products /></ProtectedRoute>} />
        <Route path="rapports" element={<ProtectedRoute roles={["patron", "associe"]}><Reports /></ProtectedRoute>} />
        <Route path="depenses" element={<ProtectedRoute roles={["patron", "associe"]}><Expenses /></ProtectedRoute>} />
        <Route path="comptabilite" element={<ProtectedRoute roles={["patron", "associe"]}><Comptabilite /></ProtectedRoute>} />
        <Route path="pharmacies" element={<ProtectedRoute roles={["patron", "associe", "vendeur"]}><Consignations /></ProtectedRoute>} />
        <Route path="utilisateurs" element={<ProtectedRoute roles={["patron"]}><Users /></ProtectedRoute>} />
        <Route path="parametres" element={<ProtectedRoute roles={["patron"]}><Settings /></ProtectedRoute>} />
        <Route path="ministere" element={<ProtectedRoute roles={["patron"]}><AdminMinistere /></ProtectedRoute>} />
        <Route path="avis" element={<ProtectedRoute roles={["patron", "associe"]}><Reviews /></ProtectedRoute>} />
        <Route path="suivi" element={<ProtectedRoute roles={["patron", "associe"]}><ProjectTracker /></ProtectedRoute>} />
        <Route path="partenaires" element={<ProtectedRoute roles={["patron", "associe"]}><Partners /></ProtectedRoute>} />
        <Route path="mode-emploi" element={<Guide />} />
      </Route>

      <Route path="/partenaire" element={<ProtectedRoute roles={["partenaire"]}><PartnerDashboard /></ProtectedRoute>} />

      <Route path="*" element={<Navigate to="/boutique" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
